// extracted by mini-css-extract-plugin
export default {"base":"ClearStampsRow_base__nSAJC","card":"ClearStampsRow_card__R8Q7J","cardContentEmpty":"ClearStampsRow_cardContentEmpty__olNSi"};